<template>
  <div class="dispersion-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>n = c / v$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：三棱镜分光 -->
      <div class="canvas-mixed simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 三棱镜 -->
            <path d="M 180 60 L 260 160 H 100 Z" fill="rgba(255,255,255,0.1)" stroke="#888" stroke-width="2" />
            
            <!-- 入射白光 -->
            <line x1="20" y1="120" x2="140" y2="110" stroke="#fff" stroke-width="4" opacity="0.8" />
            <text x="30" y="140" fill="#fff" font-size="10">白光入射</text>

            <!-- 色散光束 -->
            <g v-for="(color, i) in spectrum" :key="i">
                <line x1="140" y1="110" :x2="170 + i*2" :y2="105 + i*2" :stroke="color" stroke-width="2" />
                <line :x1="170 + i*2" :y1="105 + i*2" :x2="380" :y2="40 + i*25" :stroke="color" stroke-width="3" opacity="0.8" />
            </g>
         </svg>

         <div class="hud-top">
            <div class="badge">n_violet > n_red</div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <label>三棱镜折射率 (n)</label>
               <el-slider v-model="indexScale" :min="1.2" :max="1.8" :step="0.01" size="mini"></el-slider>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>由于介质对不同频率的光<strong>折射率 n</strong> 不同（紫光大，红光小），白光在经过三棱镜时会发生偏折角度的差异，从而分解为七色光谱。这就是<strong>色散</strong>现象。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DispersionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      indexScale: 1.5,
      spectrum: ['#ff4757', '#ffa502', '#eccc68', '#2ed573', '#1e90ff', '#3742fa', '#a442f1']
    }
  }
}
</script>

<style scoped lang="scss">
.dispersion-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .badge { color: #a442f1; font-weight: bold; font-size: 0.7rem; border: 1px solid #a442f1; padding: 2px 8px; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } }
.discovery-note { background: rgba(255, 255, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
